import { render, staticRenderFns } from "./vAddVendorModal.vue?vue&type=template&id=74d4b29a"
import script from "./vAddVendorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vAddVendorModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports